import { gql } from '@apollo/client';

export const INSTRUMENT_STUDENTS_QUERY = gql`
  query InstrumentStudents($id: uuid!, $limit: Int!, $offset: Int!) {
    instruments_by_pk(id: $id) {
      id
      student_instruments(limit: $limit, offset: $offset) {
        student {
          id
          gdpr_name
          student_locations {
            location {
              name
              id
            }
          }
        }
      }
      student_instruments_aggregate {
        aggregate {
          count
        }
      }
    }
  }
`;
